import { useEffect, useState } from "react";
import { RouteConstants } from "../../Core/Constants/RouteConstants";
import type { PaymentSummaryModel } from "../../Core/Models/PaymentModels";
import StripeService from "../../Core/Services/Stripe.service";
import { ButtonPiece } from "../../Shared/UI/ButtonPiece";
import { PaymentStatusCardPiece, PaymentSummaryPiece } from "./Pieces";
import { getPaymentStatusCopyFn } from "./Functions";

export const PaymentsComponent = ({
  mode,
}: {
  mode: "success" | "cancel";
}) => {
  const [summary, setSummary] = useState<PaymentSummaryModel>({
    booking: null,
    payment: null,
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const bookingId = searchParams.get("booking_id") || "";
    const sessionId = searchParams.get("session_id") || "";

    if (!bookingId) {
      return;
    }

    setSummary(
      StripeService.reconcileCheckoutResult(
        bookingId,
        sessionId,
        mode === "success" ? "completed" : "cancelled"
      )
    );
  }, [mode]);

  const copy = getPaymentStatusCopyFn(mode);

  return (
    <section className="section-shell">
      <div className="grid gap-6 xl:grid-cols-[1.1fr_0.9fr]">
        <PaymentStatusCardPiece
          description={copy.description}
          eyebrow={copy.eyebrow}
          title={copy.title}
        />
        <PaymentSummaryPiece summary={summary} />
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <ButtonPiece appearance="secondary" to={RouteConstants.booking}>
          {mode === "success" ? "Book another session" : "Return to booking"}
        </ButtonPiece>
        <ButtonPiece appearance="ghost" to={RouteConstants.packages}>
          Review packages
        </ButtonPiece>
      </div>
    </section>
  );
};
